import { createFileRoute, redirect } from "@tanstack/react-router";
import { getCachedSession } from "../auth/client";

/**
 * Root route gate that forwards to the correct shell route.
 * Contract: return no UI; always redirect to login, waitlist, or home
 * based on the cached session used by route entrypoint loaders.
 */
export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    const { data } = await getCachedSession();
    if (data) {
      if (data.user.status === "pending") {
        throw redirect({ to: "/waitlist" });
      }
      throw redirect({ to: "/home" });
    } else {
      throw redirect({ to: "/login" });
    }
  },
});
